import { DeliveryOrderDetailPage } from "@/features/delivery-order/pages/DeliveryOrderDetailPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/delivery-order/$id/detail")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["delivery_order.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: DeliveryOrderDetailPage,
});
